/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var createDevToolTransformer = function () { return function (declarations) { return declarations; }; };
if (process.env.NODE_ENV !== 'production') {
    if (typeof document !== 'undefined') {
        // Accept both camel cased and capitalized vendor properties
        var hyphenateRegex_1 = /(?:^(ms|moz|webkit))|[A-Z]/g;
        var propertyCache_1 = {};
        // Default ignore some font face properties that doesn't exist on elements
        var defaultIgnores_1 = ['font-display', 'src', 'unicode-range'];
        function hyphenateProperty(property) {
            return property in propertyCache_1
                ? propertyCache_1[property]
                : (propertyCache_1[property] = property.replace(hyphenateRegex_1, '-$&').toLowerCase());
        }
        var dummy_1 = document.createElement('div').style;
        function validateDeclaration(property, fullValue) {
            var _a = String(fullValue).split(/(?: !(important))$/), value = _a[0], priority = _a[1];
            dummy_1.setProperty(property, value, priority);
            var isValid = dummy_1.length > 0;
            while (dummy_1.length > 0) {
                dummy_1.removeProperty(dummy_1[dummy_1.length - 1]);
            }
            return isValid;
        }
        // Copied from core/utils/debugging.ts
        var issueValue_1 = '%o';
        function issueFormatter(message, object, highlight) {
            if (highlight === void 0) { highlight = {}; }
            var issueArgs = [];
            var issueObject = {};
            for (var key in object) {
                var isIssue = key in highlight;
                issueObject[isIssue ? "%c" + key + "%c" : key] = isIssue ? issueValue_1 : object[key];
                if (isIssue) {
                    issueArgs.push('font-weight: bold; text-decoration: underline', 'font-weight: normal; text-decoration: none', object[key]);
                }
            }
            var block = JSON.stringify(issueObject, null, 2);
            for (var key in highlight) {
                block = block.replace("  \"%c" + key + "%c\": \"" + issueValue_1 + "\"", "  %c\"" + key + "\"%c: " + issueValue_1);
            }
            return __spreadArrays([message + "\n\n" + block], issueArgs);
        }
        createDevToolTransformer = function (options) {
            if (options === void 0) { options = {}; }
            var ignores = defaultIgnores_1.concat(options.ignoreProperties || []);
            return function (declarations) {
                var properties = Object.keys(declarations);
                var _loop_1 = function (property) {
                    var _a, _b;
                    var hyphenatedProperty = hyphenateProperty(property);
                    var value = declarations[property];
                    if (!ignores.every(function (ignore) {
                        return (typeof ignore === 'string' && ignore !== hyphenatedProperty) ||
                            (ignore instanceof RegExp && !ignore.test(hyphenatedProperty));
                    })) {
                        return "continue";
                    }
                    if (Array.isArray(value)) {
                        for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                            var entry = value_1[_i];
                            if (!validateDeclaration(hyphenatedProperty, entry)) {
                                console.warn.apply(console, issueFormatter("The browser ignored the CSS fallback value `" + entry + "` in:", declarations, (_a = {},
                                    _a[property] = value,
                                    _a)));
                            }
                        }
                    }
                    else if (value) {
                        if (!validateDeclaration(hyphenatedProperty, value)) {
                            console.warn.apply(console, issueFormatter("The browser ignored the CSS in:", declarations, (_b = {},
                                _b[property] = value,
                                _b)));
                        }
                    }
                };
                for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
                    var property = properties_1[_i];
                    _loop_1(property);
                }
                return declarations;
            };
        };
    }
}
var index = createDevToolTransformer();

export default index;
export { createDevToolTransformer };
